export default __webpack_public_path__ + "static/media/Ies_Panel1_ENG.1e72140c.jpg";